"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = {
  shadow: {
    4: '0px 2px 4px rgba(0, 0, 0, 0.2)',
    6: '0px 2px 6px rgba(0, 0, 0, 0.2)',
    8: '0px 2px 8px rgba(0, 0, 0, 0.2)',
    12: '0px 2px 12px rgba(0, 0, 0, 0.2)',
    16: '0px 2px 16px rgba(0, 0, 0, 0.2)',
    24: '0px 2px 24px rgba(0, 0, 0, 0.2)',
    32: '0px 2px 32px rgba(0, 0, 0, 0.2)',
    'shadow-xxs': '0px 2px 4px rgba(0, 0, 0, 0.2)',
    'shadow-xs': '0px 2px 6px rgba(0, 0, 0, 0.2)',
    'shadow-s': '0px 2px 8px rgba(0, 0, 0, 0.2)',
    'shadow-m': '0px 2px 12px rgba(0, 0, 0, 0.2)',
    'shadow-l': '0px 2px 16px rgba(0, 0, 0, 0.2)',
    'shadow-xl': '0px 2px 24px rgba(0, 0, 0, 0.2)',
    'shadow-xxl': '0px 2px 32px rgba(0, 0, 0, 0.2)'
  },
  glow: {
    4: '0px 2px 4px rgba(255, 255, 255, 0.2)',
    6: '0px 2px 6px rgba(255, 255, 255, 0.2)',
    8: '0px 2px 8px rgba(255, 255, 255, 0.2)',
    12: '0px 2px 12px rgba(255, 255, 255, 0.2)',
    16: '0px 2px 16px rgba(255, 255, 255, 0.2)',
    24: '0px 2px 24px rgba(255, 255, 255, 0.2)',
    32: '0px 2px 32px rgba(255, 255, 255, 0.2)',
    'glow-xxs': '0px 2px 4px rgba(255, 255, 255, 0.2)',
    'glow-xs': '0px 2px 6px rgba(255, 255, 255, 0.2)',
    'glow-s': '0px 2px 8px rgba(255, 255, 255, 0.2)',
    'glow-m': '0px 2px 12px rgba(255, 255, 255, 0.2)',
    'glow-l': '0px 2px 16px rgba(255, 255, 255, 0.2)',
    'glow-xl': '0px 2px 24px rgba(255, 255, 255, 0.2)',
    'glow-xxl': '0px 2px 32px rgba(255, 255, 255, 0.2)'
  }
};